<template>
  <div>
    <span>Salut</span>
  </div>
</template>

<script>
import { GenericList, Sort, DefaultValues, Filter } from '@/mixins'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'GroupList',
  mixins: [GenericList, Sort, DefaultValues, Filter],
  data () {
    return {
      service: 'GROUP',
      query: {
        is_commercial: 0
      }
    }
  },
  computed: {
    ...mapState(['lastOpenedItemPk']),
    ...mapGetters(['canAddUsers'])
  },
  created () {
    if (this.$route.name === 'GroupListInterne') {
      this.query.is_commercial = 0
    } else {
      this.query.is_commercial = 1
    }
  }
}
</script>
